import { render, staticRenderFns } from "./AvatarParticipationStatus.vue?vue&type=template&id=504f94a2&scoped=true"
import script from "./AvatarParticipationStatus.vue?vue&type=script&lang=js"
export * from "./AvatarParticipationStatus.vue?vue&type=script&lang=js"
import style0 from "./AvatarParticipationStatus.vue?vue&type=style&index=0&id=504f94a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f94a2",
  null
  
)

export default component.exports